import { IconButton, Menu as MenuBase, MenuItem as MenuItemBase, MenuItemProps, MenuProps } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Linked, useLinked } from '@type-r/react';
import * as React from 'react';

const MenuOpen = React.createContext<Linked<boolean>>(undefined);

export const Menu = ( { icon, ...props }: {icon?: React.ReactNode} & Omit<MenuProps, 'open'> ) => {
    const anchorRef = React.createRef<HTMLSpanElement>();
    const $open = useLinked(false);

    return (
        <>
        <span
            ref={ anchorRef }
            onClick={ e => {
                e.stopPropagation();
                $open.true();
            } }
        >
            { icon || (
                <IconButton aria-label="Move to non-ar">
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            ) }
        </span>
        <MenuOpen.Provider value={ $open }>
            <MenuBase
                {...props}
                anchorEl={ () => anchorRef.current }
                open={ $open.value }
                onBackdropClick={ e => e.stopPropagation() }
                onClose={ $open.false }
            >
                { props.children }
            </MenuBase>
        </MenuOpen.Provider>
        </>
    );
};

export const MenuItem = ( { onSelect,...props } : { onSelect?: () => void } & MenuItemProps ) => {
    const $open = React.useContext(MenuOpen);
    
    return (
        <MenuItemBase {...(props as any)} onClick={ () => {
                if ($open) {
                    $open.set(false);
                }
                if (onSelect) {
                    onSelect();
                }
            } }>
            { props.children }
        </MenuItemBase>
    );
};
